export default __webpack_public_path__ + "static/media/moego-logo.e6ef2b93.png";